import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { usePermissions } from '@/app/hooks/usePermissions';
import { getPartner } from '@/modules/partner/store/selectors';
import { AppDispatch } from '@/root-store';
import { scrollUp } from '@/shared/actions/scrollUp';

import { useCards } from './hooks/useCards';
import { getToDoListData } from './selectors';
import { ICardContext } from './types';
import { ToDoView } from './view';

interface IProps {
  selectToDoListData?: (state: any) => ICardContext;
  onNavigate: (uri: string) => void;
}

const ToDo: React.VFC<IProps> = React.memo(
  ({ onNavigate, selectToDoListData = getToDoListData }) => {
    usePermissions('viewTodo');

    const dispatch = useDispatch() as AppDispatch;

    useEffect(() => {
      dispatch(scrollUp());
    }, [dispatch]);

    const cards = useCards({ selectToDoListData, onNavigate });
    const partner = useSelector(getPartner);

    return (
      <ToDoView
        cards={cards}
        hasTitle={true}
        hasProgress={true}
        isPartnerActive={partner?.accessStatus === 'active'}
      />
    );
  },
);

ToDo.displayName = 'ToDo';

export { ToDo };
